import React from "react";
import { resolveParticipantName } from "../../JobShiftPreStart/jobShiftPreStartUtils";
import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const isFlaggedAnswer = (question = {}, answer = null) => {
  if (!question || !answer) {
    return false;
  }

  const responseConfig = question.response_config || {};
  const flagOnValue = responseConfig.flagOnValue;

  if (flagOnValue !== undefined && flagOnValue !== null) {
    return `${answer.value || ""}` === `${flagOnValue}`;
  }

  return Boolean(answer.flagged_response);
};

export default function ReadinessFlaggedIncorrectiveQuestions({ questions }) {
  const flaggedRows = Array.isArray(questions)
    ? questions.reduce((rows, questionEntry, questionIndex) => {
      const question = questionEntry && questionEntry.question ? questionEntry.question : null;
      if (!question || question.disabled || question.active !== true) {
        return rows;
      }
      const answerScope = question && question.answer_scope ? question.answer_scope : "supervisor";
      const questionText = question && question.question_text ? question.question_text : "";
      const supervisorParticipant = questionEntry && questionEntry.supervisorParticipant ? questionEntry.supervisorParticipant : null;
      const supervisorAnswer = questionEntry && questionEntry.supervisorAnswer ? questionEntry.supervisorAnswer : null;
      const workerAnswers = questionEntry && Array.isArray(questionEntry.workerAnswers) ? questionEntry.workerAnswers : [];
      const questionNumber = `Q${questionIndex + 1}`;

      if (isFlaggedAnswer(question, supervisorAnswer)) {
        rows.push({
          key: `supervisor-${question && question.id ? question.id : questionIndex}`,
          questionNumber,
          questionText,
          participantName: answerScope === "worker" ? resolveParticipantName(supervisorParticipant) : "",
          flaggedResponse: supervisorAnswer && supervisorAnswer.flagged_response ? supervisorAnswer.flagged_response : ""
        });
      }

      workerAnswers.forEach(({ answer, participant, participantIndex }) => {
        if (isFlaggedAnswer(question, answer)) {
          rows.push({
            key: `worker-${question && question.id ? question.id : questionIndex}-${participant && participant.staff_id ? participant.staff_id : participantIndex}`,
            questionNumber,
            questionText,
            participantName: resolveParticipantName(participant),
            flaggedResponse: answer && answer.flagged_response ? answer.flagged_response : ""
          });
        }
      });

      return rows;
    }, [])
    : [];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum || ""}`.trim()}>3</span>
        Flagged Non-Conformances &amp; Corrective Actions
      </div>
      <div className={styles.PreviewSectionBody} style={{ minHeight: "auto" }}>
        <table className={styles.PreviewTable}>
          <tbody>
            {flaggedRows.length > 0 ? flaggedRows.map(({ key, questionNumber, questionText, participantName, flaggedResponse }) => (
              <tr key={key}>
                <td style={{ width: "45%" }}>
                  <div className={styles.PreStartFlaggedQuestionLine}>
                    <span className={styles.PreStartFlaggedQuestionNumber}>{questionNumber || "-"}</span>
                    <span>{questionText || "-"}</span>
                    {participantName ? <span className={styles.PreStartQuestionScope}>({participantName})</span> : null}
                  </div>
                </td>
                <td>
                  <span className={styles.PreStartFlaggedResponseValue}>{flaggedResponse}</span>
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan={2}>
                  <span className={styles.PreStartQuestionGuidance} style={{ fontSize: "12px" }}>No non-conformances flagged during this readiness checklist.</span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
